import validator from "validator";
import isEmpty from "../utils/isEmpty";
const validateUser = (user) => {
  const errors = {};
  const { name, date, person } = user;

  if (validator.isEmpty(name)) {
    errors.name = "Name field is must.";
  }
  if (validator.isEmpty(date)) {
    errors.date = "Date field is must.";
  }
  if (validator.isEmpty(person)) {
    errors.person = "Person(s) per head field is must.";
  }

  return {
    errors: errors,
    isInvalid: !isEmpty(errors),
  };
};

export default validateUser;
